export enum AztecScannerStep {
    INTRODUCTION = 'INTRODUCTION',
    SCANNER = 'SCANNER',
    NOTIFICATION = 'NOTIFICATION',
}
